@import './ionic-selectable-modal.component';
@import './ionic-selectable-modal.ios.vars.component';

// iOS ionic-sectable
// --------------------------------------------------
